import { ReactNode } from "react";
import { Box, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export default function AdminPageHeader({ title, subtitle, action }: AdminPageHeaderProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        mb: "22px",
      }}
    >
      <Box>
        <Typography
          component="h1"
          sx={{
            fontFamily: theme.typography.fontFamilyDisplay,
            fontSize: { xs: 22, lg: 26 },
            lineHeight: 1.15,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              mt: "5px",
              fontSize: "13.5px",
              color: "text.secondary",
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>

      {action && <Box>{action}</Box>}
    </Box>
  );
}
